import { createAsyncThunk } from '@reduxjs/toolkit';
import { _auditUrls } from '@custom/Utils/constants/apiUrls';

const billingAuditList = createAsyncThunk('Billing Audit Logs', async (obj:any) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
    let url = `${_auditUrls.billingList}`
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body:JSON.stringify(obj)
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default billingAuditList;
